var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-photos-counter u-absolute-full"},[_c('div',{staticClass:"more-photos-counter__count"},[_vm._v("+"+_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }